import {ValueObject} from '@s-ui/domain'

export class FreeAdsAvailableAdPublisherValueObject extends ValueObject {
  #hasUserAdsAvailable

  constructor({hasUserAdsAvailable}) {
    super()
    this.#hasUserAdsAvailable = hasUserAdsAvailable
  }

  static create({hasUserAdsAvailable}) {
    return new FreeAdsAvailableAdPublisherValueObject({hasUserAdsAvailable})
  }

  static createFromApiResponse({HasUserAdsAvailable}) {
    return new FreeAdsAvailableAdPublisherValueObject({hasUserAdsAvailable: HasUserAdsAvailable})
  }

  toJSON() {
    return {hasUserAdsAvailable: this.#hasUserAdsAvailable}
  }
}

export const factory = FreeAdsAvailableAdPublisherValueObject.create
